import React from 'react';

export default function IconPortfolio() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2545_9726)">
        <path
          d="M13.5648 9.75055C12.824 12.1189 10.6132 13.8339 7.99984 13.8339C4.77984 13.8339 2.1665 11.2205 2.1665 8.00055C2.1665 5.38721 3.8815 3.17638 6.24984 2.43555"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.8333 8.00033H8V2.16699C11.2258 2.16699 13.8333 4.78033 13.8333 8.00033Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2545_9726">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(1 1)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
